import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=6f61de3a&scoped=true"
import script from "./order_detail.vue?vue&type=script&lang=js"
export * from "./order_detail.vue?vue&type=script&lang=js"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=6f61de3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f61de3a",
  null
  
)

export default component.exports